var _rect, _g, _circle, _rect2, _rect3, _path, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmptytripconf(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 383,
    height: 349,
    viewBox: "0 0 383 349",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4649_46672",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 383,
    height: 331
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.0327148,
    y: 0.796875,
    width: 382.6,
    height: 329.508,
    rx: 16,
    fill: "url(#paint0_linear_4649_46672)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4649_46672)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("rect", {
    x: -16.75,
    y: -0.84375,
    width: 38.5,
    height: 38.5,
    fill: "#E2E7F0",
    fillOpacity: 0.3,
    stroke: "#E2E7F0",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 22.25,
    y: -0.84375,
    width: 38.5,
    height: 38.5,
    fill: "#E2E7F0",
    fillOpacity: 0.3,
    stroke: "#E2E7F0",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 100.25,
    y: -0.84375,
    width: 38.5,
    height: 38.5,
    fill: "#E2E7F0",
    fillOpacity: 0.3,
    stroke: "#E2E7F0",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_4649_46672)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 99.5,
    y: -1.59375,
    width: 40,
    height: 40,
    fill: "#1784B6",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 100.25,
    y: -0.84375,
    width: 38.5,
    height: 38.5,
    stroke: "#1C9FDA",
    strokeWidth: 1.5
  })), /*#__PURE__*/React.createElement("rect", {
    x: 139.25,
    y: -0.84375,
    width: 38.5,
    height: 38.5,
    fill: "#E2E7F0",
    fillOpacity: 0.3,
    stroke: "#E2E7F0",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 217.25,
    y: -0.84375,
    width: 38.5,
    height: 38.5,
    fill: "#E2E7F0",
    fillOpacity: 0.3,
    stroke: "#E2E7F0",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_4649_46672)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 216.5,
    y: -1.59375,
    width: 40,
    height: 40,
    fill: "#1784B6",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 217.25,
    y: -0.84375,
    width: 38.5,
    height: 38.5,
    stroke: "#1C9FDA",
    strokeWidth: 1.5
  })), /*#__PURE__*/React.createElement("rect", {
    x: 256.25,
    y: -0.84375,
    width: 38.5,
    height: 38.5,
    fill: "#E2E7F0",
    fillOpacity: 0.3,
    stroke: "#E2E7F0",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 295.25,
    y: -0.84375,
    width: 38.5,
    height: 38.5,
    fill: "#E2E7F0",
    fillOpacity: 0.3,
    stroke: "#E2E7F0",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 373.25,
    y: -0.84375,
    width: 38.5,
    height: 38.5,
    fill: "#E2E7F0",
    fillOpacity: 0.3,
    stroke: "#E2E7F0",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: -17.5,
    y: 37.4062,
    width: 40,
    height: 40,
    fill: "#E2E7F0",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 21.5,
    y: 37.4062,
    width: 40,
    height: 40,
    fill: "#E2E7F0",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 60.5,
    y: 37.4062,
    width: 40,
    height: 40,
    fill: "#E2E7F0",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 99.5,
    y: 37.4062,
    width: 40,
    height: 40,
    fill: "#E2E7F0",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 138.5,
    y: 37.4062,
    width: 40,
    height: 40,
    fill: "#E2E7F0",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 177.5,
    y: 37.4062,
    width: 40,
    height: 40,
    fill: "#E2E7F0",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 256.25,
    y: 38.1562,
    width: 38.5,
    height: 38.5,
    fill: "#E2E7F0",
    fillOpacity: 0.3,
    stroke: "#E2E7F0",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 295.25,
    y: 38.1562,
    width: 38.5,
    height: 38.5,
    fill: "#E2E7F0",
    fillOpacity: 0.3,
    stroke: "#E2E7F0",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_f_4649_46672)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 294.5,
    y: 37.4062,
    width: 40,
    height: 40,
    fill: "#1784B6",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 295.25,
    y: 38.1562,
    width: 38.5,
    height: 38.5,
    stroke: "#1C9FDA",
    strokeWidth: 1.5
  })), /*#__PURE__*/React.createElement("rect", {
    x: 334.25,
    y: 38.1562,
    width: 38.5,
    height: 38.5,
    fill: "#E2E7F0",
    fillOpacity: 0.3,
    stroke: "#E2E7F0",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 373.25,
    y: 38.1562,
    width: 38.5,
    height: 38.5,
    fill: "#E2E7F0",
    fillOpacity: 0.3,
    stroke: "#E2E7F0",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_f_4649_46672)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 372.5,
    y: 37.4062,
    width: 40,
    height: 40,
    fill: "#1784B6",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 373.25,
    y: 38.1562,
    width: 38.5,
    height: 38.5,
    stroke: "#1C9FDA",
    strokeWidth: 1.5
  })), /*#__PURE__*/React.createElement("rect", {
    x: -16.75,
    y: 77.1562,
    width: 38.5,
    height: 38.5,
    stroke: "#E2E7F0",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 22.25,
    y: 77.1562,
    width: 38.5,
    height: 38.5,
    stroke: "#E2E7F0",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 61.25,
    y: 77.1562,
    width: 38.5,
    height: 38.5,
    fill: "#E2E7F0",
    fillOpacity: 0.3,
    stroke: "#E2E7F0",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_f_4649_46672)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 60.5,
    y: 76.4062,
    width: 40,
    height: 40,
    fill: "#1784B6",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 61.25,
    y: 77.1562,
    width: 38.5,
    height: 38.5,
    stroke: "#1C9FDA",
    strokeWidth: 1.5
  })), /*#__PURE__*/React.createElement("rect", {
    x: 100.25,
    y: 77.1562,
    width: 38.5,
    height: 38.5,
    fill: "#E2E7F0",
    fillOpacity: 0.3,
    stroke: "#E2E7F0",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 139.25,
    y: 77.1562,
    width: 38.5,
    height: 38.5,
    fill: "#E2E7F0",
    fillOpacity: 0.3,
    stroke: "#E2E7F0",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_f_4649_46672)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 138.5,
    y: 76.4062,
    width: 40,
    height: 40,
    fill: "#1784B6",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 139.25,
    y: 77.1562,
    width: 38.5,
    height: 38.5,
    stroke: "#1C9FDA",
    strokeWidth: 1.5
  })), /*#__PURE__*/React.createElement("rect", {
    x: 217.25,
    y: 77.1562,
    width: 38.5,
    height: 38.5,
    fill: "#E2E7F0",
    fillOpacity: 0.3,
    stroke: "#E2E7F0",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 295.25,
    y: 77.1562,
    width: 38.5,
    height: 38.5,
    fill: "#E2E7F0",
    fillOpacity: 0.3,
    stroke: "#E2E7F0",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 373.25,
    y: 77.1562,
    width: 38.5,
    height: 38.5,
    fill: "#E2E7F0",
    fillOpacity: 0.3,
    stroke: "#E2E7F0",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 22.25,
    y: 116.156,
    width: 38.5,
    height: 38.5,
    fill: "#E2E7F0",
    fillOpacity: 0.3,
    stroke: "#E2E7F0",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 139.25,
    y: 116.156,
    width: 38.5,
    height: 38.5,
    fill: "#E2E7F0",
    fillOpacity: 0.3,
    stroke: "#E2E7F0",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 217.25,
    y: 116.156,
    width: 38.5,
    height: 38.5,
    fill: "#E2E7F0",
    fillOpacity: 0.3,
    stroke: "#E2E7F0",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 256.25,
    y: 116.156,
    width: 38.5,
    height: 38.5,
    fill: "#E2E7F0",
    fillOpacity: 0.3,
    stroke: "#E2E7F0",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 334.25,
    y: 116.156,
    width: 38.5,
    height: 38.5,
    fill: "#E2E7F0",
    fillOpacity: 0.3,
    stroke: "#E2E7F0",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 373.25,
    y: 116.156,
    width: 38.5,
    height: 38.5,
    fill: "#E2E7F0",
    fillOpacity: 0.3,
    stroke: "#E2E7F0",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter6_f_4649_46672)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 60.5,
    y: 154.406,
    width: 40,
    height: 40,
    fill: "#1784B6",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 61.25,
    y: 155.156,
    width: 38.5,
    height: 38.5,
    stroke: "#1C9FDA",
    strokeWidth: 1.5
  })), /*#__PURE__*/React.createElement("rect", {
    x: 100.25,
    y: 155.156,
    width: 38.5,
    height: 38.5,
    stroke: "#E2E7F0",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 178.25,
    y: 155.156,
    width: 38.5,
    height: 38.5,
    fill: "#E2E7F0",
    fillOpacity: 0.3,
    stroke: "#E2E7F0",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 256.25,
    y: 155.156,
    width: 38.5,
    height: 38.5,
    fill: "#E2E7F0",
    fillOpacity: 0.3,
    stroke: "#E2E7F0",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 295.25,
    y: 155.156,
    width: 38.5,
    height: 38.5,
    fill: "#E2E7F0",
    fillOpacity: 0.3,
    stroke: "#E2E7F0",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 373.25,
    y: 155.156,
    width: 38.5,
    height: 38.5,
    fill: "#E2E7F0",
    fillOpacity: 0.3,
    stroke: "#E2E7F0",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: -16.75,
    y: 194.156,
    width: 38.5,
    height: 38.5,
    fill: "#E2E7F0",
    fillOpacity: 0.3,
    stroke: "#E2E7F0",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 60.5,
    y: 193.406,
    width: 40,
    height: 40,
    fill: "#E2E7F0",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 139.25,
    y: 194.156,
    width: 38.5,
    height: 38.5,
    fill: "#E2E7F0",
    fillOpacity: 0.3,
    stroke: "#E2E7F0",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 178.25,
    y: 194.156,
    width: 38.5,
    height: 38.5,
    fill: "#E2E7F0",
    fillOpacity: 0.3,
    stroke: "#E2E7F0",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 217.25,
    y: 194.156,
    width: 38.5,
    height: 38.5,
    fill: "#E2E7F0",
    fillOpacity: 0.3,
    stroke: "#E2E7F0",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 256.25,
    y: 194.156,
    width: 38.5,
    height: 38.5,
    fill: "#E2E7F0",
    fillOpacity: 0.3,
    stroke: "#E2E7F0",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 295.25,
    y: 194.156,
    width: 38.5,
    height: 38.5,
    fill: "#E2E7F0",
    fillOpacity: 0.3,
    stroke: "#E2E7F0",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 334.25,
    y: 194.156,
    width: 38.5,
    height: 38.5,
    fill: "#E2E7F0",
    fillOpacity: 0.3,
    stroke: "#E2E7F0",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 373.25,
    y: 194.156,
    width: 38.5,
    height: 38.5,
    fill: "#E2E7F0",
    fillOpacity: 0.3,
    stroke: "#E2E7F0",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 22.25,
    y: 233.156,
    width: 38.5,
    height: 38.5,
    fill: "#E2E7F0",
    fillOpacity: 0.3,
    stroke: "#E2E7F0",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 61.25,
    y: 233.156,
    width: 38.5,
    height: 38.5,
    fill: "#E2E7F0",
    fillOpacity: 0.3,
    stroke: "#E2E7F0",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 100.25,
    y: 233.156,
    width: 38.5,
    height: 38.5,
    fill: "#E2E7F0",
    fillOpacity: 0.3,
    stroke: "#E2E7F0",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 139.25,
    y: 233.156,
    width: 38.5,
    height: 38.5,
    fill: "#E2E7F0",
    fillOpacity: 0.3,
    stroke: "#E2E7F0",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 178.25,
    y: 233.156,
    width: 38.5,
    height: 38.5,
    fill: "#E2E7F0",
    fillOpacity: 0.3,
    stroke: "#E2E7F0",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 217.25,
    y: 233.156,
    width: 38.5,
    height: 38.5,
    fill: "#E2E7F0",
    fillOpacity: 0.3,
    stroke: "#E2E7F0",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 256.25,
    y: 233.156,
    width: 38.5,
    height: 38.5,
    fill: "#E2E7F0",
    fillOpacity: 0.3,
    stroke: "#E2E7F0",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 295.25,
    y: 233.156,
    width: 38.5,
    height: 38.5,
    fill: "#E2E7F0",
    fillOpacity: 0.3,
    stroke: "#E2E7F0",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 334.25,
    y: 233.156,
    width: 38.5,
    height: 38.5,
    fill: "#E2E7F0",
    fillOpacity: 0.3,
    stroke: "#E2E7F0",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 373.25,
    y: 233.156,
    width: 38.5,
    height: 38.5,
    fill: "#E2E7F0",
    fillOpacity: 0.3,
    stroke: "#E2E7F0",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: -16.75,
    y: 272.156,
    width: 38.5,
    height: 38.5,
    fill: "#E2E7F0",
    fillOpacity: 0.3,
    stroke: "#E2E7F0",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 22.25,
    y: 272.156,
    width: 38.5,
    height: 38.5,
    fill: "#E2E7F0",
    fillOpacity: 0.3,
    stroke: "#E2E7F0",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 61.25,
    y: 272.156,
    width: 38.5,
    height: 38.5,
    fill: "#E2E7F0",
    fillOpacity: 0.3,
    stroke: "#E2E7F0",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 100.25,
    y: 272.156,
    width: 38.5,
    height: 38.5,
    fill: "#E2E7F0",
    fillOpacity: 0.3,
    stroke: "#E2E7F0",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 139.25,
    y: 272.156,
    width: 38.5,
    height: 38.5,
    fill: "#E2E7F0",
    fillOpacity: 0.3,
    stroke: "#E2E7F0",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 178.25,
    y: 272.156,
    width: 38.5,
    height: 38.5,
    fill: "#E2E7F0",
    fillOpacity: 0.3,
    stroke: "#E2E7F0",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 217.25,
    y: 272.156,
    width: 38.5,
    height: 38.5,
    fill: "#E2E7F0",
    fillOpacity: 0.3,
    stroke: "#E2E7F0",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 256.25,
    y: 272.156,
    width: 38.5,
    height: 38.5,
    fill: "#E2E7F0",
    fillOpacity: 0.3,
    stroke: "#E2E7F0",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 295.25,
    y: 272.156,
    width: 38.5,
    height: 38.5,
    fill: "#E2E7F0",
    fillOpacity: 0.3,
    stroke: "#E2E7F0",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 334.25,
    y: 272.156,
    width: 38.5,
    height: 38.5,
    fill: "#E2E7F0",
    fillOpacity: 0.3,
    stroke: "#E2E7F0",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 373.25,
    y: 272.156,
    width: 38.5,
    height: 38.5,
    fill: "#E2E7F0",
    fillOpacity: 0.3,
    stroke: "#E2E7F0",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: -16.75,
    y: 311.156,
    width: 38.5,
    height: 38.5,
    fill: "#E2E7F0",
    fillOpacity: 0.3,
    stroke: "#E2E7F0",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 22.25,
    y: 311.156,
    width: 38.5,
    height: 38.5,
    fill: "#E2E7F0",
    fillOpacity: 0.3,
    stroke: "#E2E7F0",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 61.25,
    y: 311.156,
    width: 38.5,
    height: 38.5,
    fill: "#E2E7F0",
    fillOpacity: 0.3,
    stroke: "#E2E7F0",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 100.25,
    y: 311.156,
    width: 38.5,
    height: 38.5,
    fill: "#E2E7F0",
    fillOpacity: 0.3,
    stroke: "#E2E7F0",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 139.25,
    y: 311.156,
    width: 38.5,
    height: 38.5,
    fill: "#E2E7F0",
    fillOpacity: 0.3,
    stroke: "#E2E7F0",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 178.25,
    y: 311.156,
    width: 38.5,
    height: 38.5,
    fill: "#E2E7F0",
    fillOpacity: 0.3,
    stroke: "#E2E7F0",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 217.25,
    y: 311.156,
    width: 38.5,
    height: 38.5,
    fill: "#E2E7F0",
    fillOpacity: 0.3,
    stroke: "#E2E7F0",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 256.25,
    y: 311.156,
    width: 38.5,
    height: 38.5,
    fill: "#E2E7F0",
    fillOpacity: 0.3,
    stroke: "#E2E7F0",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 295.25,
    y: 311.156,
    width: 38.5,
    height: 38.5,
    fill: "#E2E7F0",
    fillOpacity: 0.3,
    stroke: "#E2E7F0",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 334.25,
    y: 311.156,
    width: 38.5,
    height: 38.5,
    fill: "#E2E7F0",
    fillOpacity: 0.3,
    stroke: "#E2E7F0",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 373.25,
    y: 311.156,
    width: 38.5,
    height: 38.5,
    fill: "#E2E7F0",
    fillOpacity: 0.3,
    stroke: "#E2E7F0",
    strokeWidth: 1.5
  })))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 191,
    cy: 161.457,
    r: 71.5,
    fill: "#F1F1F1"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 162.951,
    y: 159.996,
    width: 70,
    height: 98,
    rx: 7,
    transform: "rotate(2.5 162.951 159.996)",
    fill: "#EEEEEE",
    stroke: "#999999",
    strokeWidth: 2
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 121.336,
    y: 154.135,
    width: 74,
    height: 102,
    rx: 9,
    transform: "rotate(-7.5 121.336 154.135)",
    fill: "#FAFAFA",
    stroke: "#999999",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M123.502 162.928C122.925 158.547 126.009 154.529 130.389 153.952L185.91 146.642C190.291 146.066 194.309 149.149 194.886 153.53L196.844 168.401L125.46 177.799L123.502 162.928Z",
    fill: "#EEEEEE"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 209.366,
    y: 148.598,
    width: 3,
    height: 10,
    rx: 1.5,
    transform: "rotate(82.5 209.366 148.598)",
    fill: "#999999"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 181.97,
    y: 132.031,
    width: 3,
    height: 10,
    rx: 1.5,
    transform: "rotate(-7.5 181.97 132.031)",
    fill: "#999999"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 199.547,
    y: 134.762,
    width: 3,
    height: 10,
    rx: 1.5,
    transform: "rotate(37.5 199.547 134.762)",
    fill: "#999999"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 132.922,
    y: 180.852,
    width: 58,
    height: 4,
    rx: 2,
    transform: "rotate(-7.5 132.922 180.852)",
    fill: "#DCDCDC"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 135.533,
    y: 200.68,
    width: 58,
    height: 4,
    rx: 2,
    transform: "rotate(-7.5 135.533 200.68)",
    fill: "#DCDCDC"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 138.143,
    y: 220.512,
    width: 58,
    height: 4,
    rx: 2,
    transform: "rotate(-7.5 138.143 220.512)",
    fill: "#DCDCDC"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 133.966,
    y: 188.785,
    width: 21,
    height: 4,
    rx: 2,
    transform: "rotate(-7.5 133.966 188.785)",
    fill: "#EEEEEE"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 136.577,
    y: 208.613,
    width: 21,
    height: 4,
    rx: 2,
    transform: "rotate(-7.5 136.577 208.613)",
    fill: "#EEEEEE"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 139.188,
    y: 228.441,
    width: 21,
    height: 4,
    rx: 2,
    transform: "rotate(-7.5 139.188 228.441)",
    fill: "#EEEEEE"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_4649_46672",
    x: 97.5,
    y: -3.59375,
    width: 44,
    height: 44,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "effect1_foregroundBlur_4649_46672"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_4649_46672",
    x: 214.5,
    y: -3.59375,
    width: 44,
    height: 44,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "effect1_foregroundBlur_4649_46672"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_4649_46672",
    x: 292.5,
    y: 35.4062,
    width: 44,
    height: 44,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "effect1_foregroundBlur_4649_46672"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_f_4649_46672",
    x: 370.5,
    y: 35.4062,
    width: 44,
    height: 44,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "effect1_foregroundBlur_4649_46672"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_f_4649_46672",
    x: 58.5,
    y: 74.4062,
    width: 44,
    height: 44,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "effect1_foregroundBlur_4649_46672"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_f_4649_46672",
    x: 136.5,
    y: 74.4062,
    width: 44,
    height: 44,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "effect1_foregroundBlur_4649_46672"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_f_4649_46672",
    x: 58.5,
    y: 152.406,
    width: 44,
    height: 44,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "effect1_foregroundBlur_4649_46672"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4649_46672",
    x1: 191.333,
    y1: 208.213,
    x2: 191.333,
    y2: 330.305,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9D9D9",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptytripconf);
export default __webpack_public_path__ + "static/media/emptytripconf.9e893745af18b88b8857515a428a1d0d.svg";
export { ForwardRef as ReactComponent };